import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Divider, Dropdown, Form, Icon, Label, Modal, Popup, Segment, Table, TextArea } from 'semantic-ui-react'
import Loader from '../../loader';
import Pagination from '../../pagination';
import AuthService from '../../../service/auth';
import TableUpdatesRepo from '../../../utils/repository/tableUpdatesRepo'
import { serverToLocalDate } from '../../../utils/dateTimeUtils';
import { reportStatusToLablel } from '../../../utils/labelsConverter';
import ReviewTab from '../review/review';
import KeyValue from '../../../structures/keyValePair';
import UserRepo from '../../../utils/repository/userRepo';
import useTableUpdates from '../../../hooks/tableUpdates/useTableUpdates';
import { SORT_BY, SORT_ORDER, UPDATE_PHASE } from '../../../constnats/tableUpdate';
import CompanyRepo from '../../../utils/repository/companyRepo';
import { SelectField } from '../../form/fields';
import { ROLES } from '../../../constnats/user';
import { Link } from 'react-router-dom';
import { AdministrationTabs } from '../../../pages/admin/company/company';
import RouteC from '../../../constnats/routeConstants';
import ConfirmationModal from '../../confirmationModal';
import Alert from '../../../utils/alert';
import { ReviewType, UpdatePhase, UpdatePurpose } from '../../financialTables/configuration/constants';
import ReportsRepo from '../../../utils/repository/repoertsRepo';
import { ReportField } from '../../../constnats/reportConstants';
import { ReportsUtils } from '../../../utils/reportsUtils';
import NumInput from '../../form/numInput';
import Assert from '../../../utils/asserts';
import { PathFactory } from '../../../utils/repository/utils';
import { TASK_STATUSES } from '../../../constnats/task';
import useEntityTaskExecutions from '../../../hooks/task/useEntityTaskExecutions';
import EntityTaskExecutionsTable from '../task/entityTaskExecutions/entityTaskExecutionsTable';
import { RESPONSE_STATUS } from '../../../constnats/general';
import { REVIEW_PHASES, countActiveReconciliationsByOwner, getPromotionAllowanceLimit, isAllowanceExempt, isPromotionAllowanceApplicable } from '../../../utils/promotionAllowance';
import TasksRepo from '../../../utils/repository/tasksRepo/tasksRepo';
import { REVIEW_STATUS } from '../../../constnats/review';
import { canViewFullReview, canRequestDeepRevision } from '../../../utils/reviewAccess';
import AppliedUpdateChanges from './components/appliedUpdateChanges';
import ArchivedReviewChanges from './components/archivedReviewChanges';
import './updatesTab.css';

const deleteConfirmationMsg = "Are you sure that you want to delete the update? The operation will also delete all data associated with it."

const UPDATE_PURPOSES = [
    new KeyValue(UpdatePurpose.REGULAR_UPDATE, "Regular Update"),
    new KeyValue(UpdatePurpose.DEFERRED_REVIEWS_EXECUTION, "Execution of deferred reviews"),
    new KeyValue(UpdatePurpose.MISTAKES_DETECTION, "General mistakes detection")
]

function valdateDescription(description) {
    return description.length > 5 && description.length < 1000
}

function validateMinChecks(fullChecks, visualChecks, minCDChecks) {
    return fullChecks + visualChecks + minCDChecks > 0
}

const INVALID_DESCRIPTION_MSG = 'The descriptin must be at least 5 characters long and not more than 1000.'
const INVALID_MINCHECKS_MSG = 'The update should have at least one check (Visual, Full or Core Data)'


function hasReviews(allReviews, type, minReviews) {
    Assert.notNullOrUndefined(minReviews, "Unexpected value for minReviews")
    return allReviews.filter(r => r.type === type).length >= minReviews
}

function isReadyForNextPhase(update) {

    const reviews = update.reviews.filter(r => r.status !== REVIEW_STATUS.DISCONTINUED)
    const phase = update.phase
    const qaReviewBlocker = phase === UpdatePhase.READY_FOR_QA_REVIEW ?
        hasReviews(reviews, ReviewType.VISUAL_CHECK, update.minVisualChecks) : true

    return phase !== UpdatePhase.APPLIED && phase !== UpdatePhase.DRAFT && qaReviewBlocker &&
        hasReviews(reviews, ReviewType.FULL_CHECK, update.minFullChecks) &&
        hasReviews(reviews, ReviewType.CORE_DATA_CHECK, update.minCDChecks) &&
        reviews.every(r => r.status === "APPROVED")
}

function UserSelect({ selected, disabledOptions, multiple, label, onChange, disabled }) {
    const [users, setUsers] = useState([])

    useEffect(() => {
        UserRepo.list({ userRoles: [ROLES.EMPLOYEE], includeDisabled: false },
            users =>
                setUsers(
                    users.map(r => {
                        return {
                            key: r.id,
                            text: r.fullName,
                            value: r.id
                        }
                    }))
        )
    }, [])

    const options = users.filter(u => !disabledOptions.includes(u.key))
    return (
        <Form.Field>
            <label>{label}</label>
            <Dropdown
                onChange={(a, b) => onChange(b.value)}
                value={selected}
                placeholder={label}
                {...{ multiple, options, disabled }}
                fluid selection search />
        </Form.Field>
    )
}

function CreateUpdateModal({ companyId, schemaId, summary, onSaved, onCancel }) {
    const [description, setDescription] = useState("")
    const [purpose, setPurpose] = useState(UPDATE_PURPOSES[0].key)
    const [targetReviewers, setTargetReviewers] = useState([])
    const [reportsForDeferredCheck, setReportsForDeferredCheck] = useState([])

    const [error, setError] = useState(false)
    const [loading, setLoading] = React.useState(true)

    const ownerId = AuthService.getUserId()

    function save() {
        if (valdateDescription(description)) {
            setLoading(true)
            const spec = {
                summary,
                description,
                purpose,
                targetReviewers,
                srcSchema: schemaId,
                reportsForDeferredCheck:
                    purpose === UpdatePurpose.DEFERRED_REVIEWS_EXECUTION ? reportsForDeferredCheck : []
            }

            TableUpdatesRepo.create(spec, () => {
                setLoading(false)
                onSaved()
            })
        } else {
            setError({ content: INVALID_DESCRIPTION_MSG })
        }
    }

    useEffect(() => {
        CompanyRepo.getContributors(companyId, contributors => {
            const targetReviewers = contributors
                .filter(u => ownerId !== u.id)
                .map(u => u.id)


            setTargetReviewers(targetReviewers)
            setLoading(false)
        })
    }, [companyId]);

    return loading ? <Loader /> :
        <Modal size="small" open={true}>
            <Modal.Header>Create Update</Modal.Header>
            <Modal.Content>
                <Form>
                    <SelectField value={purpose} number={false}
                        onChange={setPurpose}
                        label="Purpose" valuesMap={UPDATE_PURPOSES} />
                    Description
                    <Form.Field
                        error={error}
                        control={TextArea}
                        value={description} onChange={v => {
                            setError(false)
                            setDescription(v.target.value)
                        }} />
                    {purpose === UpdatePurpose.DEFERRED_REVIEWS_EXECUTION &&
                        <DeferredReviewReportsSelection
                            schemaId={schemaId}
                            selectedReportIds={reportsForDeferredCheck}
                            onChange={setReportsForDeferredCheck} />
                    }
                    <UserSelect
                        label="Target Reviewers"
                        disabledOptions={[ownerId]}
                        multiple={true}
                        onChange={setTargetReviewers}
                        selected={targetReviewers} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button size='mini' positive onClick={save}>
                    Create
                </Button>
                <Button size='mini' negative onClick={onCancel}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
}


function DeferredReviewReportsSelection({ schemaId, selectedReportIds, onChange }) {
    const [reports, setReports] = useState([])
    const [includeQuarterlyRelatedReports, setIncludeQuarterlyRelatedReports] = useState(false);
    const [selectedInternal, setSelectedInternal] = useState(new Set(selectedReportIds))

    useEffect(() => {
        ReportsRepo.listBySchema(schemaId, setReports)
    }, [schemaId]);

    return <>
        <Checkbox
            label="Include quarterly related reports"
            checked={includeQuarterlyRelatedReports}
            onChange={(evt, data) => {
                setIncludeQuarterlyRelatedReports(data.checked)
                if(data.checked) {
                    const reportsToInclude = new Set(selectedInternal)
                    selectedInternal.forEach(reportId => {
                        const report = reports.find(r => r[ReportField.ID] === reportId)
                        const relatedQuarterlyReports = ReportsUtils.getRelatedQuarterlyReports(report, reports)
                        relatedQuarterlyReports.forEach(r => reportsToInclude.add(r[ReportField.ID]))
                    })
                    onChange([...reportsToInclude])
                }else {
                    onChange([...selectedInternal])
                }
            }} />
        <b>Reports for deferred review:</b>
        <table className='reportsSelection' >
            <thead>
                <tr>
                    <th></th>
                    <th>Year</th>
                    <th>Period</th>
                    <th>Version</th>
                    <th>Format</th>
                    <th>Full Checks</th>
                    <th>Core Data Checks</th>
                    <th>Visual Checks</th>
                    <th>Created On</th>
                    <th>Updated On</th>
                </tr>
            </thead>
            <tbody>
                {ReportsUtils.sort(reports, true).map(report =>
                    <tr key={report.id}>
                        <td>
                            <Checkbox checked={selectedReportIds.includes(report.id)}
                                onChange={(evt, data) => {
                                    const newSelectedInternal = new Set([...selectedInternal])
                                    const newSelected = new Set([...selectedReportIds])
                                    if(data.checked) {
                                        newSelectedInternal.add(report.id)
                                        newSelected.add(report.id)
                                        if(includeQuarterlyRelatedReports) {
                                            const relatedQuarterlyReports = ReportsUtils.getRelatedQuarterlyReports(report, reports)
                                            relatedQuarterlyReports.forEach(r => newSelected.add(r.id))
                                        }
                                    } else {
                                        newSelectedInternal.delete(report.id)
                                        newSelected.delete(report.id)
                                        if(includeQuarterlyRelatedReports && selectedInternal.has(report.id)) {
                                            const relatedQuarterlyReports = ReportsUtils.getRelatedQuarterlyReports(report, reports)
                                            relatedQuarterlyReports.forEach(r => newSelected.delete(r.id))
                                        }
                                    }
                                    setSelectedInternal(newSelectedInternal)
                                    onChange([...newSelected])

                                }} />
                        </td>
                        <td>{report[ReportField.YEAR]}</td>
                        <td>{report[ReportField.PERIOD]}</td>
                        <td>{report[ReportField.TYPE]}</td>
                        <td>{report[ReportField.REPORT_TYPE]}</td>
                        <td>{report[ReportField.FULL_CHECKS_COUNT]}</td>
                        <td>{report[ReportField.CD_CHECKS_COUNT]}</td>
                        <td>{report[ReportField.VISUAL_CHECKS_COUNT]}</td>
                        <td>{serverToLocalDate(report[ReportField.CREATED_ON])}</td>
                        <td>{serverToLocalDate(report[ReportField.UPDATED_ON])}</td>
                    </tr>
                )}
            </tbody>
        </table>
    </>
}


function EditUpdateModal({ updateId, onSaved, onCancel }) {
    const [update, setUpdate] = useState(null)
    let [error, setError] = useState(false)

    useEffect(() => {
        TableUpdatesRepo.get(updateId, update => {
            setUpdate({
                updateId: update.id,
                description: update.description,
                purpose: update.purpose,
                targetReviewers: update.targetReviewers,
                ownerId: update.ownerId,
                companyId: update.companyId,
                minFullChecks: update.minFullChecks,
                minVisualChecks: update.minVisualChecks,
                minCDChecks: update.minCDChecks,
                reviewRequirementsManagedBy: update.reviewRequirementsManagedBy,
            })
        })
    }, [updateId]);


    function assingUpdateChange(change) {
        setUpdate(Object.assign({}, update, change))
        setError({})
    }

    function setOwnerId(newOwnerId) {
        const newTargetReviewers = update.targetReviewers
            .filter(userId => userId !== newOwnerId)

        assingUpdateChange({
            targetReviewers: newTargetReviewers,
            ownerId: newOwnerId
        })
    }

    function setDescription(description) {
        assingUpdateChange({ description })
    }

    function setTargetReviewers(targetReviewers) {
        targetReviewers = targetReviewers
            .filter(userId => userId !== update.ownerId)
        assingUpdateChange({ targetReviewers })
    }

    function save() {
        const error = {};
        if (!valdateDescription(update.description)) {
            error.description = { content: INVALID_DESCRIPTION_MSG }
        }

        if (!validateMinChecks(update.minFullChecks, update.minVisualChecks, update.minCDChecks)) {
            error.minchecks = { content: INVALID_MINCHECKS_MSG }
        }

        if (Object.keys(error).length) {
            setError(error)
        } else {
            TableUpdatesRepo.update(update, onSaved)
        }

    }

    function getMinReviewsInput(type, prop, disabled) {
        return <NumInput
            label={"Minimal " + type + " Checks"}
            error={disabled ? null : error.minchecks}
            value={update[prop]}
            disabled={disabled}
            onChange={newVal => assingUpdateChange({ [prop]: newVal })} />
    }

    let content
    if (update === null) {
        content = <Loader />
    } else {
        const ownerId = update.ownerId
        const isOwner = ownerId === AuthService.getUserId()
        const notUM = !AuthService.hasGlobalRole(ROLES.UPDATES_MANAGER)
        content = (
            <Modal size="large" open={true}>
                <Modal.Header>Edit Draft</Modal.Header>
                <Modal.Content>
                    <Form>
                        Description
                        <Form.Field
                            error={error.description}
                            control={TextArea}
                            value={update.description} onChange={v => {
                                setDescription(v.target.value)
                            }} />
                        <UserSelect
                            label="Target Reviewers"
                            multiple={true}
                            disabledOptions={[ownerId]}
                            onChange={setTargetReviewers}
                            selected={update.targetReviewers} />
                        <UserSelect
                            label="Owner"
                            disabled={notUM && !isOwner}
                            disabledOptions={[]}
                            onChange={setOwnerId}
                            selected={ownerId} />
                        {getMinReviewsInput("Visual", "minVisualChecks", notUM)}
                        {getMinReviewsInput("Full", "minFullChecks", notUM)}
                        {getMinReviewsInput("CD", "minCDChecks", notUM)}
                        <SelectField
                            valuesMap={[{key:"SYSTEM", value:"System"}, {key:"USER", value:"User"}]}
                            onChange={(val) => assingUpdateChange({ reviewRequirementsManagedBy: val })}
                            label='Review Requirements Managed By' 
                            disabled={notUM} 
                            value={update.reviewRequirementsManagedBy} />
                        

                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button size='mini' positive onClick={save}>
                        Save
                    </Button>
                    <Button size='mini' negative onClick={onCancel}>
                        Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        )
    }

    return content
}

function AppliedUpdateChangesModal({ updateId, onClose }) {
    return (
        <Modal size="fullscreen" open={true}>
            <Modal.Header>Changes</Modal.Header>
            <Modal.Content style={{ overflow: "scroll" }}>
                <AppliedUpdateChanges updateId={updateId} />
            </Modal.Content>
            <Modal.Actions>
                <Button size="mini" onClick={onClose}>Close</Button>
            </Modal.Actions>
        </Modal>
    )
}

function ArchivedReviewChangesModal({ reviewId, notes, restricted, onClose }) {
    return (
        <Modal size="fullscreen" open={true}>
            <Modal.Header>Changes</Modal.Header>
            <Modal.Content style={{ overflow: "scroll" }}>
                <ArchivedReviewChanges reviewId={reviewId} notes={notes} restricted={restricted} />
            </Modal.Content>
            <Modal.Actions>
                <Button size="mini" onClick={onClose}>Close</Button>
            </Modal.Actions>
        </Modal>
    )
}

function UpdatesTab({ companyId, companyName, schemaId, schemaName, reloadSchemas }) {
    const [modal, setModal] = React.useState(null)

    function createDraft(onSuccess) {
        function saveHandler() {
            onSuccess()
            setModal(null)
        }

        setModal(<CreateUpdateModal summary={companyName + " (" + schemaName + ")"}
            {...{ schemaId, companyId }} onSaved={saveHandler} onCancel={() => setModal(null)} />)
    }

    return <div>
        {modal}
        <UpdatesTable
            initialOrder={SORT_ORDER.DESC}
            includeMistakes
            query={{ srcSchema: schemaId }}
            onCreateDraft={createDraft}
            onUpdatesChange={reloadSchemas}
        />
    </div>
}

function UpdatesTable({
    query,
    detailed = true,
    includeMistakes = false,
    clientFilter,
    ownerOptions,
    onUpdatesChange,
    onCreateDraft,
    initialOrder = SORT_ORDER.ASC,
    initialSort = SORT_BY.CREATED_ON

}) {
    const [sortBy, setSortBy] = useState(initialSort)
    const [order, setOrder] = useState(initialOrder)
    const [ownerId, setOwnerId] = useState(null)
    const [allOwners, setAllOwners] = useState([])
    const isAdmin = AuthService.hasAnyGlobalRole([ROLES.ADMIN])

    useEffect(() => {
        if (!ownerOptions) {
            UserRepo.list({ userRoles: [ROLES.EMPLOYEE], includeDisabled: true },
                users => setAllOwners(users))
        }
    }, [!!ownerOptions])

    const { updates, loading, refetch, page, setPage, totalPages } = useTableUpdates({
        ...query,
        sortBy,
        order,
        ...(ownerId ? { owner: ownerId } : {})
    })

    function handleUpdatesChange() {
        refetch()
        if (onUpdatesChange) { onUpdatesChange() }
    }

    const ownerList = ownerOptions || allOwners
    const visibleUpdates = clientFilter ? updates.filter(clientFilter) : updates
    const newUpdateAllowed = !updates.find(u => u.phase !== "APPLIED")

    return <>
        {onCreateDraft && newUpdateAllowed &&
            <Button floated='right' size='mini' primary onClick={() => onCreateDraft(handleUpdatesChange)}>
                Prepare Update
            </Button>
        }
        <SelectField label="Sort By: "
            valuesMap={[
                new KeyValue(SORT_BY.CREATED_ON, "Created On"),
                new KeyValue(SORT_BY.UPDATED_ON, "Updated On"),
            ]}
            value={sortBy}
            onChange={key => setSortBy(key)} />
        <SelectField label="Order: "
            valuesMap={[
                new KeyValue(SORT_ORDER.ASC, "ASC"),
                new KeyValue(SORT_ORDER.DESC, "DESC")
            ]}
            value={order}
            onChange={key => setOrder(key)} />
        <SelectField number={true} label="Owner: "
            valuesMap={[new KeyValue(null, "All"), ...ownerList.map(u => new KeyValue(u.id, u.fullName))]}
            value={ownerId}
            onChange={key => setOwnerId(key)} />
        {loading ? <Loader /> : visibleUpdates.length === 0 ? <p>No updates.</p> :
            <>

                <Table striped className="revewRequiestTable">
                    <Table.Header>
                        <Table.Row >
                            <Table.HeaderCell collapsing></Table.HeaderCell>
                            <Table.HeaderCell collapsing></Table.HeaderCell>
                            <Table.HeaderCell>ID</Table.HeaderCell>
                            {detailed ?
                                <Table.HeaderCell>Description</Table.HeaderCell>
                                :
                                <Table.HeaderCell>Summary</Table.HeaderCell>}

                            <Table.HeaderCell>Owner</Table.HeaderCell>
                            <Table.HeaderCell>Phase</Table.HeaderCell>
                            <Table.HeaderCell>Purpose</Table.HeaderCell>
                            <Table.HeaderCell>Reviews</Table.HeaderCell>
                            <Table.HeaderCell>Review Revision Requests</Table.HeaderCell>
                            {includeMistakes && <>
                                <Table.HeaderCell>Mistakes Score</Table.HeaderCell>
                            </>}
                            <Table.HeaderCell>Created On</Table.HeaderCell>
                            <Table.HeaderCell>Updated On</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {visibleUpdates.map((u, i) =>
                            <Table.Row key={u.id} warning={isReadyForNextPhase(u)}>
                                <Table.Cell collapsing>
                                    {i + 1}
                                </Table.Cell>
                                <Table.Cell collapsing className='noPadding'>
                                    <UpdateOps update={u} onUpdatesChange={handleUpdatesChange} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Link
                                        to={PathFactory.create([
                                            RouteC.EDIT_COMPANY_CONFIG_INTERNAL,
                                            u.companyId,
                                            'update',
                                            u.id,
                                            ...(u.phase === UPDATE_PHASE.APPLIED ? ['history'] : []),
                                        ])}
                                    >
                                        {u.id}
                                    </Link>
                                </Table.Cell>
                                {detailed ?
                                    <Table.Cell>
                                        <div dangerouslySetInnerHTML={{ __html: u.description.replace(/(?:\r\n|\r|\n)/g, '</br>') }}></div>
                                    </Table.Cell>
                                    :
                                    <Table.Cell>
                                        <Popup size='tiny' wide
                                            content={u.description} trigger={<Link
                                                to={PathFactory.create(
                                                    [
                                                        RouteC.EDIT_COMPANY_CONFIG_INTERNAL,
                                                        u.companyId, AdministrationTabs.UPDATES, u.srcSchemaId
                                                    ])
                                                }>{u.summary}
                                            </Link>} />
                                    </Table.Cell>
                                }
                                <Table.Cell>
                                    {u.owner.disabled ?
                                        <Label color="red" size="mini">
                                            {u.owner.fullName}
                                        </Label>
                                        : u.owner.fullName}
                                </Table.Cell>
                                <Table.Cell>
                                    {u.phase}
                                </Table.Cell>
                                <Table.Cell>
                                    {u.purpose}
                                </Table.Cell>
                                <Table.Cell className="reviewStatusCell">
                                    <Reviews reviews={u.reviews}
                                        updatePhase={u.phase}
                                        ownerId={u.ownerId}
                                        onChange={handleUpdatesChange}
                                        includeMistakes={includeMistakes}
                                        showDetails={isAdmin} />
                                </Table.Cell>
                                <Table.Cell>
                                    {u.reviewRevisionRequestsCount}
                                </Table.Cell>
                                {includeMistakes && <>
                                    <Table.Cell>
                                        <UpdateMistakesScore update={u} showScope={isAdmin} />
                                    </Table.Cell>
                                </>}
                                <Table.Cell>
                                    {serverToLocalDate(u.createdOn)}
                                </Table.Cell>
                                <Table.Cell>
                                    <DateLabel date={u.updatedOn}
                                        actionRequired={u.phase !== UpdatePhase.APPLIED} />
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </>
        }
        {!!updates.length && <Pagination page={page} totalPages={totalPages} setPage={setPage} />}
    </>
}

function UpdateMistakesScore({ update, showScope }) {

    const showMistakes = update.purpose !== UpdatePurpose.MISTAKES_DETECTION && update.purpose !== UpdatePurpose.DEFERRED_REVIEWS_EXECUTION
    const score = showMistakes ? getMistakesScoreOfUpdate(update) : "N/A"

    return score === "" ? "" :
        <Popup wide
            size='tiny'
            content={
                <>
                    Mistake Points from Peers: {Number(update.mistakePointsFromPeer).toFixed(1)}<br />
                    Mistake Points from QAs: {Number(update.mistakePointsFromQa).toFixed(1)}<br />
                    Cells Scope: {update.cellsScope}
                    <Divider />
                    Added Reports: {update.addedReports}<br />
                    Total Reports In Table: {update.totalReports}
                </>
            }
            trigger={<span>{score}{showScope && <> ({update.cellsScope}) </>}</span>}
        />
}

function getMistakesScoreOfUpdate(update) {
    if (update.mistakePointsFromPeer === null || update.mistakePointsFromQa === null) {
        return ""
    } else {
        const cellsScope = update.cellsScope
        const totalPoints = update.mistakePointsFromPeer + update.mistakePointsFromQa
        if (cellsScope === 0) {
            if (totalPoints > 0) {
                Alert.warn("Unexpected sells scope. Please contact administrator. Update:" + update.id + ", QA points:" + update.mistakePointsFromQa + ", Peer points:" + update.mistakePointsFromPeer)
            }
            return ""
        }
        return (Number(totalPoints / cellsScope) * 100).toFixed(1)
    }
}



const currentTime = new Date().getTime()
function DateLabel({ date, actionRequired }) {
    const time = new Date(date).getTime()
    const passedDays = (currentTime - time) / (1000 * 60 * 60 * 24)
    const formatedDate = serverToLocalDate(date)

    let res
    if (!actionRequired || passedDays < 2) {
        res = formatedDate
    } else {
        res = <Label color={passedDays > 4 ? "red" : "yellow"}
            size="mini">{formatedDate}</Label>
    }

    return res
}

function isMoreThanOneMonthOld(dateString) {
    const date = new Date(dateString);
    const oneMonthAgo = new Date();

    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    return date < oneMonthAgo;

}


function Reviews({ reviews, updatePhase, onChange, includeMistakes, showDetails,ownerId }) {
    const [reviewModal, setReviewModal] = React.useState(null)

    function handleReviewDeletion() {
        onChange()
        setReviewModal(null)
    }

    function handleReviewStatusChange() {
        onChange()
    }

    function openRevew(reviewId, restricted) {
        setReviewModal(<ReviewModal
            {...{ reviewId, restricted, handleReviewDeletion, handleReviewStatusChange }}
            onClose={() => setReviewModal(null)}
        />
        )
    }

    function viewArchivedReviewChanges(reviewId, notes, restricted) {
        setReviewModal(<ArchivedReviewChangesModal
            {...{ reviewId, notes, restricted }}
            onClose={() => setReviewModal(null)}
        />
        )
    }

    function requestDeepRevision(reviewId) {
        setReviewModal(<ConfirmationModal
            msg="Are you sure that you want to request a deep revision of this automatic review?"
            onConfirm={() => {
                TableUpdatesRepo.requestDeepRevision(reviewId, () => {
                    Alert.success("Deep revision requested.")
                    onChange()
                })
                setReviewModal(null)
            }}
            onCancel={() => setReviewModal(null)}
        />)
    }

    return <>
        {reviewModal}
        {reviews.map(r => {
            const restricted = !canViewFullReview(r, updatePhase, ownerId)
            return (
                <Segment key={r.id} className='cursorPointer'
                    onClick={() => r.phase === "ARCHIVED" ? viewArchivedReviewChanges(r.id, r.notes, restricted) : openRevew(r.id, restricted)} >
                    {showDetails && <><b>{r.id}</b><br /></>}
                    {r.owner.disabled ?
                        <Label color="red" size="mini">
                            {r.owner.fullName}
                        </Label>
                        : r.owner.fullName}
                    <br />
                    {r.type}
                    {r.notes && <Popup size='tiny' wide
                        content={r.notes} trigger={<span> * </span>} />}
                    <br />
                    {showDetails && <><b>{r.phase}</b><br /></>}
                    {showDetails && <><b>Resets: {r.resetsCount}</b><br /></>}
                    {reportStatusToLablel(r.status)}<br />

                    {includeMistakes && <ReviewMistakesScore review={r} showDetails={showDetails} />}

                    {serverToLocalDate(r.createdOn)} - {serverToLocalDate(r.updatedOn)}
                    {canRequestDeepRevision(r, updatePhase) && <>
                        <br />
                        <Button size="mini" basic compact
                            onClick={(e) => {
                                e.stopPropagation()
                                requestDeepRevision(r.id)
                            }}>
                            Request Deep Revision
                        </Button>
                    </>}
                </Segment>
            )
        })}
    </>
}

function ReviewMistakesScore({ review, showDetails }) {

    const score = getMistakesScoreOfReview(review)
    const mistakePoints = score === "" ? "N/A" : Number(review.mistakePoints).toFixed(1)

    return <>
        <Popup size='tiny' wide
            content={
                <>
                    Mistake Points: {mistakePoints}<br />
                    Cells Scope: {review.cellsScope}
                    <Divider />
                    Reviewed Reports: {review.reportsScope}
                </>
            } trigger={<div> 
                <p className='mr-0'>Mistakes Score: {score === "" ? "N/A" : score}</p>
                {showDetails && <>
                    <p className='mr-0'>Cells Scope: {review.cellsScope}</p>
                    <p className='mr-0'>Mistake Points: {mistakePoints}</p>
                </>}
                </div>} />
    </>

}

function getMistakesScoreOfReview(review) {
    const cellsScope = review.cellsScope
    const mistakePoints = review.mistakePoints
    if (cellsScope === null || mistakePoints === null) {
        return ""
    } else if (cellsScope === 0) {
        if (mistakePoints > 0 && review.status !== REVIEW_STATUS.DISCONTINUED && !isMoreThanOneMonthOld(review.updatedOn)) {
            Alert.warn("Unexpected sells scope. Please contact administrator. Review:" + review.id)
        }
        return ""
    }
    return Number(mistakePoints / cellsScope * 100).toFixed(2)
}


function ReviewModal({ reviewId, restricted, handleReviewDeletion, handleReviewStatusChange, onClose }) {
    const modalRef = useRef(null)
    return <Modal open={true} size='fullscreen' ref={modalRef}>
        <Modal.Header>
            Review
            <Icon color='grey' name='close'
                className='cursorPointer floatRight' onClick={onClose} />
        </Modal.Header>
        <Modal.Content>
            <ReviewTab containerRef={modalRef} reviewId={reviewId} restricted={restricted} onDeleted={handleReviewDeletion}
                onReviewStatusChange={handleReviewStatusChange} />
        </Modal.Content>
        <Modal.Actions>
            <Button size='mini' onClick={onClose}>
                Close
            </Button>
        </Modal.Actions>
    </Modal>
}

const getTaskExecutionsMessage = (executions) => {
    return executions.length ? "There are PENDING tasks associated with the company." : "";
}

const taskStatuses = TASK_STATUSES.filter(s => s !== 'COMPLETED' && s !== "PENDING_REVIEW")

function UpdateOps({ update, onUpdatesChange, editDraft }) {
    const [modal, setModal] = React.useState(null)
    const [loading, setLoading] = React.useState(false)
    const [allowedReviewTypes, setAllowedReviewTypes] = React.useState(null)


    function discardUpdate(updateId) {
        setModal(<ConfirmationModal
            msg={deleteConfirmationMsg}
            onConfirm={() => {
                TableUpdatesRepo.delete(updateId, onUpdatesChange)
                setModal()
            }}
            onCancel={() => setModal()} />)
    }

    function applyUpdate(updateId) {
        setLoading(true)
        TableUpdatesRepo.apply(updateId, () => {
            setLoading(false)
            onUpdatesChange()
        })
    }

    function editDraft(update) {
        function saveHandler() {
            onUpdatesChange()
            setModal()
        }

        setModal(<EditUpdateModal updateId={update.id} onSaved={saveHandler}
            onCancel={() => setModal()} />)
    }

    function promptPeerReview(updateId) {
        markAsReadyForReview("Are you sure that you want to request a peer review?", () =>
            TableUpdatesRepo.markAsReadyForPeerReview(updateId, onUpdatesChange))
    }

    function markAsReadyForPeerReview(updateId) {
        // Exempt service/admin accounts skip the allowance check entirely.
        if (isAllowanceExempt(AuthService.getFullName())) {
            promptPeerReview(updateId)
            return
        }
        // Only reconciliations other than deferred review execution require allowance.
        if (!isPromotionAllowanceApplicable(update)) {
            promptPeerReview(updateId)
            return
        }
        setLoading(true)
        TableUpdatesRepo.findAll(
            { phases: REVIEW_PHASES },
            (updates) => {
                setLoading(false)
                const ownerId = AuthService.getUserId()
                const limit = getPromotionAllowanceLimit(ownerId)
                const activeCount = countActiveReconciliationsByOwner(updates).get(ownerId) ?? 0
                if (activeCount >= limit) {
                    Alert.warn(`You are out of promotion allowance — you already have ${activeCount} of your ${limit} allowed reconciliation updates in Peer/QA review. Finish one before moving another reconciliation draft to Peer Review.`)
                    return
                }
                promptPeerReview(updateId)
            },
            // Fail open on a transient fetch error rather than hard-blocking a legit promotion.
            () => {
                setLoading(false)
                promptPeerReview(updateId)
            }
        )
    }

    function requestAutomaticReview(updateId) {
        setModal(<ConfirmationModal 
            onConfirm={() =>  {
                TableUpdatesRepo.requestAutomaticReview(updateId, onUpdatesChange);
                setModal();
            }}
            onCancel={() => setModal()}
            msg="Are you sure that you want to request an automatic review?"
        />)
    }

    function markAsReadyForQaReview(updateId) {
        markAsReadyForReview("Are you sure that you want to request a QA review?", () =>
            TableUpdatesRepo.markAsReadyForQaReview(updateId, onUpdatesChange))
    }

    function requestReviewsRevision(updateId) {
        markAsReadyForReview("Are you sure that you want to request a revision of the reviews?", () =>
            TableUpdatesRepo.requestReviewsRevision(updateId, onUpdatesChange))
    }

    function markAsReadyForReview(msg, remoteCall) {
        TasksRepo.getTaskExecutionsByEntity(update.companyId, 0, taskStatuses, (response) => {
                setModal(<ConfirmationModal
                    msg={`${getTaskExecutionsMessage(response.data?.content ?? [])} ${msg}`}
                    onConfirm={() => {
                        remoteCall();
                        setModal();
                    }}
                    onCancel={() => setModal()}
                >
                   {!!response.data?.content?.length && 
                   <EntityTaskExecutionsTable entityId={update.companyId} statuses={taskStatuses} />}
                </ConfirmationModal>);
        });

    }

    function startReview(updateId, reviewType) {
        setLoading(true)
        TableUpdatesRepo.startReview(
            { updateId, reviewType }, () => {
                setLoading(false)
                onUpdatesChange()
            })
    }

    function viewAppliedUpdateChanges(update) {
        setModal(<AppliedUpdateChangesModal updateId={update.id} onClose={() => setModal()} />)
    }

    function getOp(name, onClick) {
        return {
            key: name,
            size: "mini",
            text: name,
            value: name,
            onClick: onClick
        }
    }

    const ops = []

    const phase = update.phase
    const updateId = update.id

    if (phase !== UpdatePhase.APPLIED) {
        const isCurrentUserUpdateOwner = update.ownerId === AuthService.getUserId()
        const isUpdateManager = AuthService.hasGlobalRole(ROLES.UPDATES_MANAGER)

        if (isCurrentUserUpdateOwner) {
            if (phase === UpdatePhase.DRAFT) {
                ops.push(getOp("Mark as ready for Peer Review", () => markAsReadyForPeerReview(updateId)))
            } else if (phase === UpdatePhase.READY_FOR_PEER_REVIEW) {
                ops.push(getOp("Mark as ready for QA Review", () => markAsReadyForQaReview(updateId)))
            } else if (phase === UpdatePhase.READY_FOR_QA_REVIEW && isReadyForNextPhase(update)) {
                ops.push(getOp("Apply", () => applyUpdate(updateId)))
            }
            if (
                AuthService.hasAnyGlobalRole([ROLES.BETA_FEATURE_TESTER_ROLE]) &&
                phase !== UpdatePhase.DRAFT &&
                phase !== UpdatePhase.APPLIED &&
                (update.purpose === UpdatePurpose.REGULAR_UPDATE || update.purpose === UpdatePurpose.DEFERRED_REVIEWS_EXECUTION)
            ) {
                ops.push(getOp('DO NOT PRESS Request Automatic Review', () => requestAutomaticReview(updateId)));
            }

            if (update.reviews.find(r => r.status === "APPROVAL_AUTO_REJECTED" || r.status === "REJECTED")) {
                ops.push(getOp("Request Review Revision", () => requestReviewsRevision(updateId)))
            }
        } else if (!update.reviews.find(r => r.ownerId === AuthService.getUserId())) {
            if (allowedReviewTypes) {
                for (const type of allowedReviewTypes) {
                    if(type === ReviewType.VISUAL_CHECK && !AuthService.hasAnyGlobalRole([ROLES.QA])) {
                        continue;
                    }
                    ops.push(getOp("Start " + type + " Review", () => startReview(updateId, type)))
                }
            }
        }
        ops.push(getOp("Edit", () => editDraft(update)))
        if(isUpdateManager) {
            ops.push(getOp("Delete", () => discardUpdate(updateId)))
        }
    } else {
        ops.push(getOp("View Changes", () => viewAppliedUpdateChanges(update)))
    }

    return <>
        {loading && <Loader />}
        {modal}
        <Dropdown
            className='icon fieldOps'
            size="mini"
            icon="ellipsis vertical"
            options={ops}
            onOpen={() => {
                if (!allowedReviewTypes && phase !== UpdatePhase.APPLIED
                    && update.ownerId !== AuthService.getUserId()
                    && !update.reviews.find(r => r.ownerId === AuthService.getUserId())) {
                    TableUpdatesRepo.getAllowedReviewTypes(updateId, (response) => setAllowedReviewTypes(response.data))
                }
            }}
            trigger={<></>} />
    </>

}

export { UpdatesTab, UpdatesTable }
